import { useState } from "react";
import { Button, Card, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import {
  cleanDisplayAmount,
  customerOrderNumber,
  formatBookingDate,
  statusTag,
} from "./bookingDisplay";

const formatFlightTime = (value) => {
  if (!value) return "Time unavailable";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return new Intl.DateTimeFormat("en-SG", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(date);
};

export const FlightsSummary = ({ booking }) => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const flights = Array.isArray(booking.flights) ? booking.flights : [];
  const visibleFlights = expanded ? flights : flights.slice(0, 3);
  const status = statusTag(booking);

  const openDetails = () => navigate(`/my-bookings/flights/${booking.orderId}`);

  return (
    <Card
      className="booking-card booking-card-clickable"
      bodyStyle={{ padding: 0 }}
      onClick={openDetails}
      hoverable
    >
      <div className="booking-card-header">
        <div className="booking-card-service">
          <span className="booking-card-icon" aria-hidden="true">✈️</span>
          <div>
            <h4>Flights</h4>
            <span className="booking-card-date">Booked {formatBookingDate(booking.orderDate) || "date unavailable"}</span>
          </div>
        </div>
        <div className="booking-card-reference-block">
          <div className="booking-references">
            <span>Order No: <strong>{customerOrderNumber(booking)}</strong></span>
          </div>
          <Tag color={status.color}>{status.text}</Tag>
        </div>
      </div>

      <div className="booking-card-body">
        <div className="booking-card-summary booking-flight-segments">
          {visibleFlights.length > 0 ? visibleFlights.map((flight, index) => (
            <div className="booking-flight-segment" key={`${flight.flightNo || "flight"}-${index}`}>
              <strong>{flight.departCity || flight.departAirport || "Departure"} ({flight.departAirport || "—"}) → {flight.arriveCity || flight.arriveAirport || "Arrival"} ({flight.arriveAirport || "—"})</strong>
              <span>{formatFlightTime(flight.departDateTime)} – {formatFlightTime(flight.arriveDateTime)}</span>
              <small>Flight {flight.flightNo || "number unavailable"}</small>
            </div>
          )) : <p>Flight itinerary is not available yet.</p>}
          {flights.length > 3 && (
            <Button type="link" onClick={(event) => { event.stopPropagation(); setExpanded((current) => !current); }}>
              {expanded ? "Show fewer flights" : `Show all ${flights.length} flights`}
            </Button>
          )}
        </div>
        <div className="booking-card-total">
          <span>Paid Price</span>
          <strong>{cleanDisplayAmount(booking)}</strong>
          <Button onClick={(event) => { event.stopPropagation(); openDetails(); }}>View details</Button>
        </div>
      </div>
    </Card>
  );
};
